<div class="group-col"
     [style.width.px]="groupColWith">
  <div class="icon">
    <div class="sk-circle"></div>
  </div>
  <div class="details">
    <div class="sk-line"></div>
    <div class="sk-line"></div>
  </div>
</div>

<div class="period-cols">
  @for (_ of [].constructor(nbPeriodCols); track $index) {
  <div class="col">
    <div class="sk-line"></div>
  </div>
  }
</div>